import './index.css'

const NotFound = () => (
  <div className="not-found-bg-cont">
    <div className="not-found-card">
      <img
        src="https://assets.ccbp.in/frontend/react-js/jobby-app-not-found-img.png"
        alt="not found"
        className="not-fond-img"
      />
      <h1>Page Not Found</h1>
      <p>We are sorry, the page you are requested couls not be found</p>
    </div>
  </div>
)

export default NotFound
